<div class="profile-image-container" [ngClass]="profileImageClass">
    <img
        [src]="profileUrl"
        onError="this.src='/assets/images/thumbnailDefault.png'"
        [attr.aria-label]="altText"
        [attr.alt]="altText"
        [title]="title"
    />
</div>
